import { render, staticRenderFns } from "./TicketItemTasks.vue?vue&type=template&id=38869a92&"
import script from "./TicketItemTasks.vue?vue&type=script&lang=js&"
export * from "./TicketItemTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports